// routes/WeeklyReportRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import NewsletterPageWeekly from '../components/Frontend/NewsLetter/pages/NewsletterPageWeekly';

export const WeeklyReportRoutes = (
  <Route path="/weekly_report" element={<MainLayout />}>
    <Route index element={<NewsletterPageWeekly />} />
  </Route>
);
